import { useMemo } from "react";
import { Upload04Icon } from "../../assets/icons";
import { formatMomentDate } from "../../utils/dateHelper";
import CommonButton from "../../components/commonButton";
import { TableSearch } from "../../components/form/Fields";
import CustomTable from "../../components/table/CustomTable";
import { getUserInitial } from "../../utils/otherHelopers";
import StatusChip from "../../components/statusChip/StatusChip";

const InquiryList = ({
  data,
  setCurrentPage,
  setSearchTerm,
  searchTerm,
  handleOpenViewModal,
  handleExportInquiry,
  canExport,
  pagination,
}) => {
  const columns = useMemo(
    () => [
      {
        id: "property_id",
        header: "PROPERTY ID",
        cell: (_, row) =>
          row?.property ? `# ${row.property.property_number_id}` : "-",
      },
      {
        id: "name",
        header: "NAME",
        cell: (_, row) => (
          <div className="d-flex align-items-center gap-2">
            <div className="profile-icon">
              {row?.user
                ? getUserInitial(
                  `${row.user.first_name || ""} ${row.user.last_name || ""}`,
                )
                : "-"}
            </div>
            <p className="ms-1 fw-medium mb-0 text-capitalize">
              {row?.user
                ? `${row.user.first_name || ""} ${row.user.last_name || ""}`.trim()
                : "-"}
            </p>
          </div>
        ),
      },
      {
        id: "mobile_number",
        header: "MOBILE NUMBER",
        cell: (_, row) => row?.user?.mobile_number || "-",
      },
      {
        id: "email",
        header: "EMAIL ADDRESS",
        cell: (_, row) => row?.user?.email || "-",
      },
      {
        id: "property_type",
        header: "PROPERTY TYPE",
        cell: (_, row) =>
          row?.property ? (
            <StatusChip
              bg="success"
              pill
              title={row.property.property_type?.name}
              className="text-capitalize"
            />
          ) : (
            ""
          ),
      },
      {
        id: "possession_type",
        header: "POSSESSION TYPES",
        cell: (_, row) =>
          row?.property ? (
            <StatusChip
              bg="success"
              pill
              title={row.property.possession_type?.name}
              className="text-capitalize"
            />
          ) : (
            ""
          ),
      },
      {
        id: "inquiry_created",
        header: "INQUIRY CREATED",
        cell: (_, row) =>
          row?.created_at ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <span>{formatMomentDate(row.created_at, "DD MMM YYYY")}</span>
              <span>{formatMomentDate(row.created_at, "hh:mm A")}</span>
            </div>
          ) : (
            "-"
          ),
      },
    ],
    [],
  );

  const actionList = useMemo(
    () => [
      {
        title: "View",
        handler: (row) => {
          handleOpenViewModal(row);
        },
      },
    ],
    [handleOpenViewModal],
  );

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between gap-4">
        <TableSearch
          value={searchTerm}
          placeholder="Search Inquiry"
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />

        {canExport && data?.length > 0 && (
          <CommonButton
            icon={<Upload04Icon strokeWidth="2.0" />}
            variant="secondary"
            title="Export"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleExportInquiry();
            }}
          />
        )}
      </div>

      <CustomTable
        data={data}
        columns={columns}
        keyField="id"
        emptyMessage="No inquiries found"
        actionList={actionList}
        pagination={pagination}
      />
    </>
  );
};

export default InquiryList;
